<a [routerLink]="['/categories', category?.id.toLowerCase()]" fxFlex>
    <div fxFlex class="category-card cursor-pointer" [class.centered]="category?.title === category?.name" [style.backgroundColor]="category?.backgroundColor">
        <div class="card-wrapper" fxFlex="100%" [style.backgroundImage]="'url(' + (category?.imgUrl | scaleImage:'format') + ')'">
            <div class="category-title">{{category?.name | translate}}</div>
            <div class="category-sub-title" *ngIf="category?.title !== category?.name" translate>{{ category?.title }}</div>
            <a *ngIf="category?.title" [routerLink]="['/categories', category?.id.toLowerCase()]" translate>View all</a>
        </div>
    </div>
</a>